import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { SlArrowRightCircle  } from "react-icons/sl";

function ProjectCards(props) {
  return (
    <Card className="news-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title style={{ textAlign: "start" }}>{props.title}</Card.Title>
        <Button variant="primary" href={props.ghLink} target="_blank">
          <SlArrowRightCircle /> &nbsp;
          {props.isBlog ? "Blog" : "More"}
        </Button>
        {"\n"}
        {"\n"}
      </Card.Body>
    </Card>
  );
}
export default ProjectCards;
